module.exports = __webpack_public_path__ + "static/media/pinergy.f3852f8a.png";